module.exports = __webpack_public_path__ + "static/media/habitanalysis.d0722312.jpeg";